import { API_VERSION_ONE, handleAPI } from "../../../../../../itrust_common/utils/apiUtils";

export function specteraStyleListLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/style_list`;
  const method = 'GET'

  return {
    type: 'SPECTERA_STYLE_LIST_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraBasicListsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/basic_lists`;
  const method = 'GET'

  return {
    type: 'SPECTERA_BASIC_LISTS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraDiameterListsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/diameter_lists`;
  const method = 'GET'

  return {
    type: 'SPECTERA_DIAMETER_LISTS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraSphereListsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/sphere_lists`;
  const method = 'GET'

  return {
    type: 'SPECTERA_SPHERE_LISTS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraCylinderListsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/cylinder_lists`;
  const method = 'GET'

  return {
    type: 'SPECTERA_CYLINDER_LISTS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraAxisListsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/axis_lists`;
  const method = 'GET'

  return {
    type: 'SPECTERA_AXIS_LISTS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraBifocalListsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/bifocal_lists`;
  const method = 'GET'

  return {
    type: 'SPECTERA_BIFOCAL_LISTS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraLensesConfigurationsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/lenses_configurations`;
  const method = 'GET'

  return {
    type: 'SPECTERA_LENSES_CONFIGURATIONS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraAddPowerListsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/add_power_lists`;
  const method = 'GET'

  return {
    type: 'SPECTERA_ADD_POWER_LISTS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraAddPowerRangeListsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/add_power_range_lists`;
  const method = 'GET'

  return {
    type: 'SPECTERA_ADD_POWER_RANGE_LISTS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraContactLensIdLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/contact_lens_id`;
  const method = 'GET'

  return {
    type: 'SPECTERA_CONTACT_LENS_ID_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function specteraLensOptionsConfigurationsLoad(claimId, filters) {
  const url = `/${API_VERSION_ONE}/add_ons/rpa/vision_insurance/logs/${claimId}/spectera/lens_options_configurations`;
  const method = 'GET'

  return {
    type: 'SPECTERA_LENS_OPTIONS_CONFIGURATIONS_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

